import React, { Component } from "react";
import { connect } from "react-redux";

import { Card, Button, Table, Input, Tooltip, message, Tag } from "antd";

import {
  req_page_smscontent,
  req_del_smscontent,
  req_edit_smscontent,
} from "../../api";

import { usrRole } from "../../utils/dataUtil";
import {
  PAGE_SIZE,
  SORT_FIELD_NAME,
  SORT_UP_DOWN,
} from "../../utils/contrains";
import { formateShortDate } from "../../utils/dateUtil";
class CreatorNewsContent extends Component {
  state = {
    loading: false,
    deviceWidth: 0,
    userLevel: "NORMAL",
    item: {},
    // 分頁參數
    items: [],
    pagination: {
      current: 1,
      pageSize: PAGE_SIZE,
      total: 0,
    },
    columnSort: SORT_FIELD_NAME,
    orderBy: SORT_UP_DOWN,
    searchField: "NONE",
    searchValue: "",
    filterStatus: "NA", // INTERVAL/ERROR/YET/OVER

    domnloadFile: "",
    isShowModal: false,
    isEditModal: false,
    isAddModal: false,
    week: 0,
    nowSaturday: "",
    nowYear: "",
  };

  UNSAFE_componentWillMount() {
    window.removeEventListener("resize", this.resize.bind(this));
    this.init();
    this.init_columns();
  }

  componentDidMount() {
    window.addEventListener("resize", this.resize.bind(this));
    this.resize();
    this.api_page_items(1);
  }

  resize() {
    this.setState({ deviceWidth: window.innerWidth });
  }

  // 遠端數據處理 //////////////////////////////////////////////
  api_page_items = async (current) => {
    this.current = current; // 保存當前頁，給其他方法可看到
    const { pageSize } = this.state.pagination;
    const { searchField, searchValue, columnSort, orderBy, filterStatus } =
      this.state;
    const { token, role, userCode } = this.props.user;
    var userLevel = usrRole(role);
    this.setState({ userLevel: userLevel });

    this.setState({ loading: true, items: [] });
    const result = await req_page_smscontent(
      "Normal",
      userCode,
      current,
      pageSize,
      columnSort,
      orderBy,
      searchField,
      searchValue,
      filterStatus,
      token
    );
    this.setState({ loading: false });
    //console.log(result)
    if (result.total > 0) {
      const { total } = result;
      const items = result.data;
      const pagination = {
        current: this.current,
        pageSize: this.state.pagination.pageSize,
        total,
      };
      this.setState({ items, pagination });
      //console.log(this.state);
    } else {
      const items = [];
      const pagination = {
        current: 1,
        pageSize: this.state.pagination.pageSize,
        total: 0,
      };
      this.setState({ items, pagination });
    }
  };

  api_delete_item = async (key) => {
    const { token } = this.props.user;
    const result = await req_del_smscontent(key, token);

    if (result.status === "success") {
      message.success("刪除成功");
      this.api_page_items(this.current);
    } else {
      //console.log(result)
    }
  };

  api_modify_item = async (item) => {
    const { token } = this.props.user;
    await req_edit_smscontent(item, token);
    this.api_page_items(this.current);
  };
  // 數據配置設定 //////////////////////////////////////////////
  getSaturdayOfWeek = (time) => {
    var now = time;
    var nowTime = now.getTime();
    var day = now.getDay();
    //var monday = new Date(nowTime - (day - 1) * 24 * 60 * 60 * 1000);
    var saturday = new Date(nowTime + (6 - day) * 24 * 60 * 60 * 1000);
    return saturday;
  };
  getSundayOfWeek = (time) => {
    var now = time;
    var nowTime = now.getTime();
    var day = now.getDay();
    //var monday = new Date(nowTime - (day - 1) * 24 * 60 * 60 * 1000);
    var sunday = new Date(nowTime + (7 - day) * 24 * 60 * 60 * 1000);
    return sunday;
  };
  getYearWeek = (year, month, day) => {
    var nowDay = new Date(year, month - 1, day);
    var firstYearDay = new Date(year, 0, 1);
    var nowYearDay = Math.ceil((nowDay - firstYearDay) / (24 * 60 * 60 * 1000));
    return Math.ceil((nowYearDay + (firstYearDay.getDay() + 1 - 1)) / 7);
  };

  init = () => {
    const currentdate = new Date();
    const currentweek = currentdate.getDay();
    const nextWeek =
      this.getYearWeek(
        currentdate.getFullYear(),
        currentdate.getMonth() + 1,
        currentdate.getDate()
      ) ;
    //console.log(nextWeek);
    const weekButtonStatus = currentweek === 0 ? false : true;
    const nowYear = currentdate.getFullYear();
    const nowSunday = formateShortDate(this.getSundayOfWeek(currentdate));
    this.setState({ week: nextWeek, nowSunday, nowYear, weekButtonStatus });
  };

  init_columns = () => {
    this.columns = [
      {
        title: "週別",
        width: 5,
        align: "center",
        responsive: ["md"],
        render: (item) => {
          const { week } = this.state;
          const { SendMailWeekNum } = item;
          return (
            <span
              style={
                parseInt(SendMailWeekNum) === week
                  ? { color: "blue", fontWeight: "bold" }
                  : { color: "black" }
              }
            >
              {SendMailWeekNum}
            </span>
          );
        },
      },
      {
        title: "填寫單位",
        dataIndex: "DepartmentTwName",
        width: 20,
        responsive: ["md"],
        render: (field) => {
          return (
            <div>
              <span style={{ fontSize: "1.1em" }}> {field}</span>
            </div>
          );
        },
      },
      {
        title: "分類",
        dataIndex: "DataCategory",
        width: 15,
        align: "center",
        render: (field) => {
          return (
            <div>
              <span style={{ fontSize: "1em" }}> {field}</span>
            </div>
          );
        },
      },
      {
        title: "內容",
        width: 60,
        render: (item) => {
          const { week } = this.state;
          const { SendMailWeekNum, DataContent, DataUrl } = item;
          return (
            <>
              {parseInt(SendMailWeekNum) > week ? (
                <Tag color="blue">待發行</Tag>
              ) : (
                <></>
              )}
              {parseInt(SendMailWeekNum) === week ? (
                <Tag color="red">預發行</Tag>
              ) : (
                <></>
              )}
              {parseInt(SendMailWeekNum) < week ? (
                <Tag color="default">已發行</Tag>
              ) : (
                <></>
              )}
              {DataUrl === "" ? (
                <span>{DataContent}</span>
              ) : (
                <a
                  href={DataUrl}
                  target="_blank"
                  rel="noreferrer"
                  style={{ textDecoration: "underline", color: "blue" }}
                >
                  {DataContent}
                </a>
              )}
            </>
          );
        },
      },
      {
        title: "發行者",
        dataIndex: "RecordCreatorName",
        width: 10,
        responsive: ["md"],
        render: (field) => {
          return (
            <div className="text-center">
              <span style={{ fontSize: "1.1em" }}> {field}</span>
            </div>
          );
        },
      },
    ];
  };

  // 操作互動處理 //////////////////////////////////////////////
  handle_page_size_change = (current, size) => {
    //console.log(size)
    this.setState(
      {
        pagination: {
          current: current,
          pageSize: size,
        },
      },
      () => {
        this.api_page_items(current);
      }
    );
  };

  handle_table_change = (pagination, filters, sorter, extra) => {
    if (filters) {
      const status = [...Object.values(filters).filter(Boolean)][0];
      if (status) {
        this.setState({ filterStatus: status }, () => {
          this.api_page_items(pagination.current);
        });
      } else {
        this.setState({ filterStatus: "" }, () => {
          this.api_page_items(pagination.current);
        });
      }
    } else {
      this.api_page_items(pagination.current);
    }
  };

  handle_data_refresh = () => {
    this.api_page_items(this.current);
  };

  handle_show_ui_modal = (modal, item) => {
    switch (modal) {
      case "edit":
        // console.log("item", item);
        this.setState({ isEditModal: true, item });
        break;
      default:
    }
  };

  /////////////////////////////////////////////////////////////
  render() {
    const { loading, items, pagination, searchValue } = this.state;
    const title = (
      <>
        <select
          style={{
            width: 120,
            height: "31px",
            fontSize: "0.9em",
            color: "#696969",
            borderColor: "#DCDCDC",
          }}
          onChange={(e) => this.setState({ searchField: e.target.value })}
        >
          <option value="NONE">搜索條件</option>
          <option value="SendMailWeekNum">發行週別</option>
          <option value="DataContent">內容</option>
          <option value="RecordCreatorName">發行者</option>
        </select>
        <Input
          placeholder="關鍵字"
          style={{
            width: 100,
            margin: "0 5px",
            backgroundColor: "LightYellow",
          }}
          value={searchValue}
          onChange={(event) =>
            this.setState({ searchValue: event.target.value })
          }
        />
        <Button type="primary" onClick={() => this.api_page_items(1)}>
          <i className="fas fa-search element-hidden"></i>
          <span style={{ marginLeft: "4px" }}>查詢</span>
        </Button>{" "}
        <Tooltip placement="top" title="重新整理">
          <Button type="primary" onClick={() => this.handle_data_refresh()}>
            <i className="fas fa-sync-alt"></i>
          </Button>
        </Tooltip>{" "}
      </>
    );
    return (
      <>
        <Card title={title}>
          <div style={{ color: "red" }}>
            電子報將發行{" "}
            <span style={{ color: "blue", fontWeight: "bold" }}>
              {this.state.nowYear} 年第 {this.state.week} 週{" "}
            </span>
            內容，於{" "}
            <span style={{ color: "blue", fontWeight: "bold" }}>
              {this.state.nowSunday}
            </span>{" "}
            <span style={{ color: "#8B0000", fontWeight: "bold" }}>
              週日上午08時30分
            </span>{" "}
            自動寄出
          </div>
          <Table
            bordered
            scroll={{ y: 480 }}
            loading={loading}
            rowKey="uid"
            dataSource={items}
            onChange={this.handle_table_change}
            pagination={{
              ...pagination,
              responsive: true,
              showQuickJumper: true,
              showSizeChanger: true,
              pageSizeOptions: [5, 10, 20, 50, 100],
              // onChange: this.api_page_applycase,
              onShowSizeChange: this.handle_page_size_change,
            }}
            columns={this.columns}
          />
        </Card>
      </>
    );
  }
}

export default connect(
  (state) => ({ user: state.user }),
  {}
)(CreatorNewsContent);
